// File for logic corresponding to Article Body component
import './assets/article-body.css';
